import { render, staticRenderFns } from "./DispensaFiltros.vue?vue&type=template&id=3fca67ab&"
import script from "./DispensaFiltros.vue?vue&type=script&lang=js&"
export * from "./DispensaFiltros.vue?vue&type=script&lang=js&"
import style0 from "./DispensaFiltros.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports